import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { AppService } from '@Services/app.service';
import { ISystem } from '@Shared/models/index.model';
import { MenuItem } from "@Shared/models/IMenuItem";

@Directive({
    selector: '[searchCase]',
    standalone: true
})
export class SearchCaseDirective {
  @Input('searchCase') menuItem: MenuItem;
  element: HTMLDivElement;
  system: ISystem;
  constructor(
    public appS: AppService,
    public ref: ElementRef<HTMLDivElement>
  ) {}
  ngOnInit(): void {
    this.element = this.ref.nativeElement;
    this.system = this.appS.systemMetadataMap.get(this.menuItem.system);
  }
  ngAfterViewInit(): void {
    // this.ref.nativeElement.style.borderColor = this.system.colourCode;
  }
  @HostListener('mouseover') onMouseOver() {
    this.element.style.borderColor = this.system.colourCode;
  }
  @HostListener('mouseleave') onMouseOut() {
    this.element.style.borderColor = "#d3d3d3";
  }
}
